// #region Imports

/* Telestream */
import { SET_SNACK } from '@/utils/mutation-types';

// #endregion Imports

export const snack = {

  // #region State

  state: {
    snack: undefined
  },

  // #endregion State

  // #region Mutations

  mutations: {

    [SET_SNACK](state, snack) {
      state.snack = snack;
    }

  }

  // #endregion Mutations

}